{
  "(optional)": "(valfritt)",
  "(required)": "(krävs)"
}